import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import i18n, { changeLanguage } from 'i18n';
import React from 'react';
import { connect } from 'react-redux';
import ProfileDetails from 'skyone-lib/lib/Topbar/ProfileDetails';
import options from './options';
import styles from './styles';

interface Props {
  removeStyle?: boolean;
}

const ChangeLanguage: React.FC<Props> = ({ removeStyle }) => {
  const classes = makeStyles(styles())();

  const language = i18n.language || 'pt';

  return (
    <Grid
      container
      justifyContent="flex-end"
      className={removeStyle ? classes.removeStyles : classes.dontRemoveStyles}
    >
      <ProfileDetails
        imageUrl={
          options(changeLanguage).find(item => item.language.test(language))
            ?.imageUrl || ''
        }
        name={''}
        options={options(changeLanguage).filter(
          item => !item.language.test(language)
        )}
        showArrow={true}
        overrideClasses={{
          image: {
            width: 28.64,
            marginRight: 5.36,
          },
          text: {
            padding: 0,
            fontSize: 0,
          },
        }}
        popperOverrideClasses={{
          popper: {
            marginTop: 25,
            width: 140,
            marginLeft: -40,
            backgroundColor: '#FFFFFF',
            border: `1px solid #EBEBED`,
            borderTop: 'none',
            zIndex: 1300,
            padding: 20,
            cursor: 'pointer',
          },
        }}
      />
    </Grid>
  );
};

const mapStateToProps = ({ config }) => ({
  language: config.language,
});

export default connect(mapStateToProps)(ChangeLanguage);
